import {FILES_DOC_DELETE} from "../axios";

export const axiosDeleteFiles = async (axiosPrivate, fileId, updateRequestFiles, setMessage) => {
    try {
         await axiosPrivate.delete(FILES_DOC_DELETE + `?id=${fileId}`,
            {
                headers: { 'Content-Type' : 'application/json'}
            });
        updateRequestFiles();
    } catch (err) {
        // navigate('/auth', {state: {from: location}, replace: true})
        // logout();
        if (err.response.data.includes('update or delete on table "templates"')) {
            setMessage('The template is already linked to the document and cannot be deleted');
        }
        console.error(err);
    }
}